var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',_vm._b({class:{ screenShotCanvas: true, screenShot: _vm.isScreenCapEnabled, 'overlay-page': true },on:{"mousedown":function($event){return _vm.mouseDown($event)}}},'canvas',{ width: _vm.width, height: _vm.height },false))}
var staticRenderFns = []

export { render, staticRenderFns }